
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import ClickOutside from "../VueIntegration/ClickOutside";
    import Move from "../Icons/Move.vue";
    import Cross from "../Icons/Cross.vue";
    import Tick from "../Icons/Tick.vue";
    import ContextMenu from "./ContextMenu.vue";

    @Component({
        components: {ContextMenu, Cross, Move, Tick},
        directives: {
            "click-outside": ClickOutside
        }
    })
    export default class SequenceItem extends Vue
    {
        @Prop({required: true, type: String}) text: string;
        @Prop({required: false, type: Boolean, default: false}) disabled: boolean;
        @Prop({type: Array, default: () => []}) menu: MenuItem[];
        @Prop({required: false, type: Boolean, default: () => null}) isCorrect: boolean;

        isMoveMenuShowing: boolean = false;

        click() {
            if (this.disabled)
                return;

            if (this.menu.length > 0) {
                this.isMoveMenuShowing = true;
            }
            else {
                this.$emit("add");
            }
        }

        remove() {
            this.$emit("remove");
            this.isMoveMenuShowing = false;
        }

        clicked(item: MenuItem) {
            this.$emit(item.eventCode, item.eventData);
        }

        moveNext() {
            this.$emit("moveNext");
            // Vue.nextTick().then(() => {
            //     let menu = <HTMLElement> this.$refs['next'];
            //     menu.focus();
            // });
        }

        movePrevious() {
            this.$emit("movePrevious");
            // Vue.nextTick().then(() => {
            //     let menu = <HTMLElement> this.$refs['previous'];
            //     menu.focus();
            // });
        }

        hideMenu() {
            this.isMoveMenuShowing = false;
        }

        hideMenuAndRefocus() {
            this.isMoveMenuShowing = false;
            (<HTMLElement>this.$refs["button"]).focus();
        }
    }

    export interface MenuItem {
        text: string;
        eventCode: string;
        eventData: any;
    }
